import React from 'react';
import Footer from '../layout/Footer/Footer';

const footers = [
	{ path: '/login', element: <></> },
	{ path: '/signup', element: <></> },
	{ path: '/question', element: <></> },
	{ path: '/passwordReset', element: <></> },
	{ path: '/', element: <></> },
	{ path: '*', element: <Footer /> },
];

export default footers;
